import { type ComponentPropsWithoutRef, type ReactNode, useMemo } from 'react';
import classNames from 'classnames';
import { SectionTitle } from '@/components';

type SectionProps = Omit<ComponentPropsWithoutRef<'section'>, 'title'> & {
	/** Título visual de la sección (no confundir con el atributo HTML title) */
	readonly title?: string;
	readonly children: ReactNode;
};
const classNameComponent = 'c-cnm-section';

export const Section = ({ children, className, title, ...rest }: SectionProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);

	return (
		<section className={wrapperClassName} {...rest}>
			<div className="o-container">
				{title && <SectionTitle title={title} />}
				<div className={`${classNameComponent}__content`}>{children}</div>
			</div>
		</section>
	);
};
